import {
    GEOGRAPHY_POLYGON_REQUEST,
    GEOGRAPHY_POLYGON_SUCCESS,
    GEOGRAPHY_POLYGON_FAILURE
} from '../../actions/networkInsights/geographyPolygonActions';
import { GeographyPolygon } from '../../../interfaces/networkInsightsServiceInterfaces';

interface DataGeographyPolygon {
    isFetching: boolean;
    geographyPolygon: GeographyPolygon;
}

const fetchGeographyPolygon = (dataGeographyPolygon: DataGeographyPolygon = {
    isFetching: false,
    geographyPolygon: {
        type: '',
        features: []
    }
}, action: any): DataGeographyPolygon => {
    switch (action.type) {
        case GEOGRAPHY_POLYGON_REQUEST: {
            return {
                ...dataGeographyPolygon,
                isFetching: true
            };
        }
        case GEOGRAPHY_POLYGON_SUCCESS: {
            return {
                isFetching: false,
                geographyPolygon: action.payload
            };
        }
        case GEOGRAPHY_POLYGON_FAILURE: {
            return {
                isFetching: false,
                geographyPolygon: {
                    type: '',
                    features: []
                }
            };
        }
        default:
            return dataGeographyPolygon;
    }
};

export default fetchGeographyPolygon;
